<div class="payment-spinner">
<app-spinner></app-spinner>
</div>

